import AppHeader from "../components/appheader";
import "./sectioncomplete.scss";
import { AppDataContext, ctxDefinition } from "../components/ctx";
import { useContext, useEffect, useRef, useState } from "react";
import { BrandButtonWhite } from "../components/form/buttons";
import { useNavigate } from "react-router-dom";
import NetworkError from "../components/networkError";

interface Question {
  questionId: string;
  value: any;
}

const SectionComplete = () => {
  const { userData } = useContext(AppDataContext) as ctxDefinition;
  const [textWarning, setTextWarning] = useState(false);
  const navigate = useNavigate();
  const unansweredLength = useRef(0);
  const sectionLength = useRef(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [nextSection, setNextSection] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hasError, setHasError] = useState(false);

  const goBack = () => {
    navigate(
      "/question/" +
        userData.examAnswers[userData.currentSectionId].questions[0].questionId,
      { replace: true },
    );
  };

  useEffect(() => {
    const currSection = userData.currentSectionId;
    const answers: Question[] = userData.examAnswers[currSection].questions;
    const unanswered = answers.filter((item) => item.value !== null);
    unansweredLength.current = unanswered.length;
    sectionLength.current = answers.length;
    if (unanswered.length !== answers.length) setTextWarning(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (nextSection && userData) {
      navigate("/section-end/", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, nextSection]);

  return (
    <>
      <div className="sectionCompletePage">
        <AppHeader />
        <div className="pageHeader">
          <h1>
            {userData.currentSection.includes("2b")
              ? userData.currentSection.substring(
                  0,
                  userData.currentSection.length - 1,
                )
              : userData.currentSection}
          </h1>
        </div>
        <div className="pageContent">
          {textWarning && (
            <div className="alertText">
              You only answered {unansweredLength.current} of the{" "}
              {sectionLength.current} questions in this section.
            </div>
          )}
          <div className="reviewText">
            You may go back to review and change your answers, or wait for the
            section timer to expire to move on.
          </div>
          <div className="btnHolder">
            <BrandButtonWhite onClick={goBack}>GO BACK</BrandButtonWhite>
          </div>
        </div>
      </div>
      <NetworkError open={hasError} />
    </>
  );
};

export default SectionComplete;
